/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	var $window = $(window);
	var windowWidth = $window.width(); // メディアクエリ
	
	var mql = window.matchMedia('screen and (max-width: 1024px)'); // テスト
	
	var _isTest = false; //preload
	
	(0, _module.preload)(); //toggleHeader
	
	(0, _module.toggleHeader)(); // pageTop
	
	(0, _module.pageTop)(); //showMovie
	
	(0, _module.showMovie)(); //anchorLink
	
	(0, _module.anchorLink)();
	$(window).on('load', function () {
	  if (_isTest) {
	    //アニメーション省略
	    $('#index-Loader').remove();
	    mainAnime();
	  } else {
	    setTimeout(function () {
	      $('#index-Loader').addClass("load");
	    }, 200);
	    setTimeout(function () {
	      $('#index-Loader').addClass("hidden");
	    }, 800);
	    setTimeout(function () {
	      $('#index-Loader').remove();
	    }, 2000);
	    setTimeout(function () {
	      mainAnime();
	    }, 800);
	  }
	
	  fogAnime();
	  unitModal();
	  scrollIndexAnime();
	  setTimeout(function () {
	    var $widget = $('iframe.twitter-timeline');
	    var $widgetContents = $widget.contents();
	    $widgetContents.find('.timeline-Body').css({
	      "border-top": "none",
	      "border-bottom": "none"
	    });
	  }, 1000);
	}); // ------------------------------------------------------------------------
	// mainAnime
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	var mainAnime = function mainAnime() {
	  setTimeout(function () {
	    $('.index-Keyvisual_Bg').addClass("is-animated");
	  }, 0);
	  setTimeout(function () {
	    $('.index-Keyvisual_Tri').addClass("is-animated");
	  }, 0);
	  setTimeout(function () {
	    $('.index-Keyvisual_Chara').addClass("is-animated");
	  }, 0);
	  setTimeout(function () {
	    $('.index-Keyvisual_Logo').addClass("is-animated");
	  }, 0);
	}; // ------------------------------------------------------------------------
	// fogAnime
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	var fogAnime = function fogAnime() {
	  VANTA.FOG({
	    el: "#fog",
	    mouseControls: true,
	    touchControls: true,
	    gyroControls: false,
	    minHeight: 200.00,
	    minWidth: 200.00,
	    highlightColor: 0x8affe3,
	    midtoneColor: 0xfffeaa,
	    lowlightColor: 0xffffff,
	    baseColor: 0x9eedff,
	    blurFactor: 0.69,
	    speed: 3,
	    zoom: 0.50
	  });
	}; // ------------------------------------------------------------------------
	// unitModal();
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	var unitModal = function unitModal() {
	  var $modal = $('#Unit_Stage');
	  var $modalClose = $('#Unit_Stage_Close');
	  var scrollPosition;
	  var ua = window.navigator.userAgent.toLowerCase();
	  var isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('macintosh') > -1 && 'ontouchend' in document;
	  var body = document.querySelector('body'); // 一覧から開く
	
	  $(document).on('click', '[data-modal]', function (e) {
	    e.preventDefault();
	    var target = $(this).data('modal');
	    modalOpen(target);
	  }); // 閉じるボタン
	
	  $modalClose.on('click', function (e) {
	    e.preventDefault();
	    modalClose();
	  }); // モーダルを開く
	
	  function modalOpen(target) {
	    // モーダルが開いたら、bodyにfixedを付与
	    // bodyFixedOn();
	    // console.log(target);
	    $('[data-modal-content = ' + target + ']').addClass('is-show');
	    $modal.addClass('opened'); // モーダルのスクロール位置上に
	
	    scrollUnit();
	  } // モーダルを閉じる
	
	
	  function modalClose() {
	    $('[data-modal-content]').removeClass('is-show');
	    $modal.removeClass('opened'); // モーダルが閉じられたら、スクロールのトップを取得してbodyに
	    // bodyFixedOff();
	  } //モーダルのスクロール一番上へ
	
	
	  function scrollUnit() {
	    $('#Unit_Stage,#Unit_Stage_Inner,.Unit_Stage_Profile').scrollTop(0);
	  } //bodyのスクロール固定
	
	
	  function bodyFixedOn() {
	    if (isiOS) {
	      scrollPosition = window.pageYOffset;
	      body.style.position = 'fixed';
	      body.style.top = "-".concat(scrollPosition, "px");
	    } else {
	      body.style.overflow = 'hidden';
	    } // body.style.overflow = 'hidden';
	
	  }
	
	  function bodyFixedOff() {
	    if (isiOS) {
	      body.style.removeProperty('position');
	      body.style.removeProperty('top');
	      window.scrollTo(0, scrollPosition);
	    } else {
	      body.style.removeProperty('overflow');
	    } // body.style.removeProperty('overflow');
	
	  }
	}; // ------------------------------------------------------------------------
	// scrollIndexAnime
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	var scrollIndexAnime = function scrollIndexAnime() {
	  var controller = new ScrollMagic.Controller(); //ページトップ出現
	
	  var scene = new ScrollMagic.Scene({
	    triggerElement: '#index-Contents',
	    triggerHook: 1,
	    offset: '80'
	  }).setClassToggle('#st-Top', 'st-Top-Show').addTo(controller); //　スクロールで発火系
	
	  var targets = document.querySelectorAll(".js-scrollAnimation");
	  var targetsArray = Array.prototype.slice.call(targets); //Array
	
	  targetsArray.forEach(function (target) {
	    //シーンを作成
	    var scene3 = new ScrollMagic.Scene({
	      triggerElement: target,
	      triggerHook: .99
	    }).setClassToggle(target, "is-animated").addTo(controller);
	  }); //　スクロールで発火系 背景
	
	  var targetsBgPink = document.querySelectorAll(".js-scrollBg");
	  var targetsBgPinkArray = Array.prototype.slice.call(targetsBgPink); //Array
	
	  targetsBgPinkArray.forEach(function (targetsBgPink) {
	    //シーンを作成
	    new ScrollMagic.Scene({
	      triggerElement: targetsBgPink,
	      triggerHook: 1,
	      duration: '100%'
	    }).on("progress", function (prog) {
	      // 使いたいシーンに対してprogressイベントを設定します
	      var p = prog.progress; // 0～1の値が入ってきます
	
	      anime({
	        targets: targetsBgPink,
	        translateY: .2 * p * -100 + "%",
	        easing: 'easeOutSine',
	        duration: 2000
	      });
	    }).addTo(controller);
	  }); //背景
	  // new ScrollMagic.Scene({
	  //   triggerElement: $(window).innerHeight(),
	  //   triggerHook: 1,
	  //   duration: $(window).innerHeight() * 10
	  //   // duration: "200%"
	  // })
	  // .on("progress", function (prog) { // 使いたいシーンに対してprogressイベントを設定します
	  //   var p = prog.progress; // 0～1の値が入ってきます
	  //   anime({
	  //     targets:"#index-Contents_Bg",
	  //     backgroundPositionY: (.5 * p) * -100 + "%",
	  //     easing: 'easeOutCubic',
	  //     duration: 100,
	  //     elasticity: 0
	  //   });
	  // })
	  // .addTo(controller);
	};

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.anchorLink = exports.showMovie = exports.pageTop = exports.toggleHeader = exports.preload = void 0;
	var headerFlag = false;
	var stHeaderNav = document.getElementById('st-Header_Nav');
	var stHeaderBg = document.getElementById('st-Header_Bg');
	var headerButton = document.getElementById('st-Menu'); // ------------------------------------------------------------------------
	// preload
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	var preload = function preload() {
	  history.replaceState(null, null, null);
	  window.addEventListener('popstate', function () {
	    $('body').addClass('preload');
	    headerFlag = false;
	    stHeaderNav.classList.remove('opened');
	    headerButton.classList.remove('opened');
	    stHeaderBg.classList.remove('opened');
	    stHeaderNav.classList.add('closed');
	    headerButton.classList.add('closed');
	    stHeaderBg.classList.add('closed'); // setTimeout(function(){
	    //   $('body').removeClass('preload');
	    // },100);
	  }, false);
	  $(window).on('load', function () {
	    $("body").removeClass("preload");
	  });
	}; // ------------------------------------------------------------------------
	// toggleHeader
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.preload = preload;
	
	var toggleHeader = function toggleHeader() {
	  headerButton.addEventListener('click', function () {
	    if (!headerFlag) {
	      // $('#st-Header_Navi').css({'display':'block'});
	      setTimeout(function () {
	        stHeaderNav.classList.remove('closed');
	        headerButton.classList.remove('closed');
	        stHeaderBg.classList.remove('closed');
	        stHeaderNav.classList.add('opened');
	        headerButton.classList.add('opened');
	        stHeaderBg.classList.add('opened');
	        headerFlag = true;
	      }, 0);
	    } else {
	      stHeaderNav.classList.remove('opened');
	      headerButton.classList.remove('opened');
	      stHeaderBg.classList.remove('opened');
	      stHeaderNav.classList.add('closed');
	      headerButton.classList.add('closed');
	      stHeaderBg.classList.add('closed');
	      headerFlag = false; // setTimeout(function(){
	      //   // $('#st-Header_Navi').css({'display':'none'});
	      // },0);
	    }
	  }, false);
	}; // ------------------------------------------------------------------------
	// pageTop
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.toggleHeader = toggleHeader;
	
	var pageTop = function pageTop() {
	  $("#st-Top").on("click", function () {
	    var linkSpeed = 800;
	    $("html, body").animate({
	      scrollTop: 0
	    }, linkSpeed, "easeOutExpo");
	    return false;
	  });
	}; // ------------------------------------------------------------------------
	// showMovie
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.pageTop = pageTop;
	
	var showMovie = function showMovie() {
	  var $modal = $('#sw-Youtube');
	  var $content = $('#sw-Youtube_Content'); // open
	
	  $('.js-Youtube').on('click', function () {
	    var dataID = $(this).attr('data-youtube');
	    $('#sw-Youtube').css({
	      'opacity': '0',
	      'display': 'block'
	    }).stop().animate({
	      'opacity': '1',
	      'width': 100 + '%',
	      'height': 100 + 'vh',
	      'top': 0,
	      'left': 0
	    }, 300, 'easeOutQuart', function () {
	      //iframe append
	      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/' + dataID + '?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>'); // fadeIn
	
	      $modal.stop().fadeIn(400);
	      return false;
	    });
	  }); //close
	
	  $('#sw-Youtube_Close,#sw-Youtube_Overlay').on('click', function () {
	    $('#sw-Youtube').css({
	      'opacity': '1'
	    }).stop().animate({
	      'opacity': '0'
	    }, 300, 'easeOutQuart', function () {
	      $('#sw-Youtube').css({
	        'display': 'none'
	      });
	      $content.children('iframe').remove();
	    });
	  });
	}; // ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.showMovie = showMovie;
	
	var anchorLink = function anchorLink() {
	  //ページ外からのページ内リンク
	  var urlHash = location.hash;
	
	  if (urlHash) {
	    $('body,html').stop().scrollTop(0);
	    setTimeout(function () {
	      var target = $(urlHash);
	      var position = target.offset().top - 0;
	      $('body,html').stop().animate({
	        scrollTop: position
	      }, 500);
	    }, 200);
	  }
	
	  var linkSpeed = 1000;
	  var linkAdjust = 0; //ページ内リンク
	
	  $("a[href^='#']").on("click", function () {
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({
	      scrollTop: linkPosition + linkAdjust
	    }, linkSpeed, "easeInOutQuint");
	    return false;
	  });
	  $(".anchor-link").on("click", function () {
	    var linkHref = $(this).attr("href");
	    var linkHash = linkHref.replace("./", "");
	    var linkTarget = $(linkHash == "#" || linkHash == "" ? 'html' : linkHash);
	    var linkPosition = linkTarget.offset().top;
	
	    if (headerFlag) {
	      // stHeader.classList.remove('opened');
	      stHeaderNav.classList.remove('opened');
	      headerButton.classList.remove('opened');
	      stHeaderBg.classList.remove('opened'); // stHeader.classList.add('closed');
	
	      stHeaderNav.classList.add('closed');
	      headerButton.classList.add('closed');
	      stHeaderBg.classList.add('closed');
	      headerFlag = false;
	    }
	
	    $("html, body").animate({
	      scrollTop: linkPosition - linkAdjust
	    }, linkSpeed, "easeInOutQuint");
	    return false;
	  });
	};
	
	exports.anchorLink = anchorLink;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index/app.bundle.js